import React from 'react'
import { connect } from 'react-redux'
import { registerVolunteer } from '../actions'

class RegisterVolunteer extends React.Component {
    constructor(){
        super()
        this.state={
            username:'',
            password:'',
            organization_name:'',
            address:'',
            email:'',
            phone:'',
        }
    }

    handleChange3 = (evt) => {
        evt.preventDefault()
        this.setState({
            [evt.target.name]: evt.target.value,
        })
    }

    handleSubmit = (evt) => {
        evt.preventDefault()
        const { username, password, organization_name, address, email, phone } = this.state
        this.props.registerVolunteer(username, password, organization_name, address, email, phone)
        this.setState({username:'', password:'', organization_name:'', address:'', email:'', phone:'',})
    }

    logout = (evt) => {
        evt.preventDefault()
        localStorage.removeItem('token')
        this.props.history.push('/loginVolunteer')
    }

    render(){
        const { username, password, organization_name, address, email, phone } = this.state
        return (
            <div>
                 <div className='signupheader'>
                    <h1>Volunteer Sign Up</h1>
                    <p>Thanks for your interest!</p>
                </div>
                <form onSubmit={this.handleSubmit}>
                    <input type="text" name="username" placeholder="New Username" value={username} onChange={this.handleChange3} required/><br/>
                    <input type="password" name="password" placeholder="New Volunteer Password" value={password} onChange={this.handleChange3} required /><br/>
                    <input type="text" name="organization_name" placeholder="New Volunteer Organization Name" value={organization_name} onChange={this.handleChange3} required /><br/>
                    <input type="text" name="address" placeholder="New Volunteer Address" value={address} onChange={this.handleChange3} required /><br/>
                    <input type="text" name="email" placeholder="New Volunteer Email" value={email} onChange={this.handleChange3} required /><br/>
                    <input type="text" name="phone" placeholder="New Volunteer Phone Number" value={phone} onChange={this.handleChange3} required /><br/>
                    <button type="submit">Sign Up</button>
                </form>
                <button type="button" onClick={this.logout}>Log Out</button>
            </div>
        )
    }
}

const mapDispatchToProps = {
    registerVolunteer
}

export default connect(null, mapDispatchToProps)(RegisterVolunteer)